import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash, faXmark, faCheck } from "@fortawesome/free-solid-svg-icons";
import moment from 'moment';

const ItemTableForStockCredit = (props) => {
    return (
        <div className="itemList-table ">
            <div className="table-container overflow-y-scroll h-[34vh] max-h-[34vh]"
            >
                <table className="itemList ">
                    <thead>
                        <tr>
                            <td className='w-[4%]'>Sr.</td>
                            <td className='w-[20%]'>Item Name</td>
                            <td className='w-[10%]'>Batch No</td>
                            <td className='w-[10%]'>Exp Date</td>
                            <td className='w-[10%]'>M.R.P.</td>
                            <td className='w-[10%]'>Qty</td>
                            <td className='w-[10%]'>Free</td>
                            <td className='w-[10%]'>Rate</td>
                            <td className='w-[15%]'>Amount</td>
                            <td className='w-[10%]'>Other</td>
                            <td className='w-[11%]'>HSN Code</td>
                            <td className='w-[10%]' style={{ textAlign: "center" }}>Action</td>
                        </tr>
                    </thead>
                    <tbody>
                        {props.itemListing && props.itemListing.length > 0
                            ? props.itemListing.map((item, key) => (

                                <tr key={key}>
                                    <td>{key + 1}</td>
                                    <td>{item.itemName}</td>
                                    <td>{item.batchNo}</td>
                                    <td>{item.qty}</td>
                                    <td>{item.rate}</td>
                                    <td>{item.amount}</td>
                                    <td>{item.other}</td>
                                    <td>{item.hsnCodeName}</td>
                                    <td style={{ textAlign: "center" }}>

                                        <button
                                            className="search-btn"
                                            onClick={() => props.editItemDetails(key)}
                                        >
                                            <FontAwesomeIcon icon={faPen} />
                                        </button>
                                        {item.isFromDB ?
                                            <button
                                                className="cancel-btn"
                                                onClick={() => props.deleteItemById(item)}
                                            >
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                            :
                                            <button
                                                className="cancel-btn"
                                                onClick={() => props.deleteItemById(key)}
                                            >
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>

                                        }
                                    </td>
                                </tr>
                            ))
                            : null}
                    </tbody>
                </table>
            </div>
            <button
                disabled={props.isHideAddItem}
                className="add-btn mt-2.5 mb-4"
                onClick={() => props.openPopUpForAddingItem()}
            >
                Add Item
            </button>
        </div>
    );
};

export default ItemTableForStockCredit;